export const GET_COURSE_STATUS =
  'global/hooks/useUserCouseStatus/getCourseStatus'
